<template>
	<header class="layout-wrapper">
		<UIShLink to="/" class="logo d-iBlock-gte-768" aria-label="home">
			<UIShIcon name="logo" role="img" />
		</UIShLink>

		<UIShLink to="/" class="logo d-block-lt-768" aria-label="home">
			<UIShIcon name="logo-mini" role="img" />
		</UIShLink>

		<nav class="d-block-gte-1024">
			<ul>
				<li v-for="item in menusList">
					<UIShLink
						:label="item.title"
						:to="item.path"
						sm
						:lg="1440"
						external
						kind="gray"
					/>
				</li>
			</ul>
		</nav>

		<UIShLink
			:to="CONTACTS.phone1.link"
			class="phone"
			:label="CONTACTS.phone1.label"
			kind="white"
			external
		/>

		<UIShLinkSocial
			link="https://t.me/APP73BOT"
			icon="tg-social"
			kind="gray"
			md
			:lg="1440"
			class="social-link d-flex-gte-1024"
			target="_blank"
		/>

		<UIShLink to="/#calculator" unstyled>
			<UIShButton
				label="Узнать стоимость"
				class="price-btn d-flex-gte-1024"
				sm
				:lg="1440"
			/>
		</UIShLink>

		<UIShButton
			:class="{
				'burger-btn': true,
				'd-flex-lt-1024': true,
				opened: openMbMenu
			}"
			@click="handleToggleMobileMenu"
		>
			<template #icon-left>
				<div class="d1" />
				<div class="d2" />
				<div class="d3" />
			</template>
		</UIShButton>

		<Transition name="menu" appear>
			<ShMobileMenu
				v-if="openMbMenu"
				@close="handleToggleMobileMenu"
				class="mobile-menu"
			/>
		</Transition>
	</header>
</template>

<script setup lang="ts">
import { CONTACTS, MENUS } from '@/common/constants';

const { togglePageOverflow } = useTogglePageOverflow();

const openMbMenu = ref(false);

const menusList = computed(() => MENUS.filter((m) => m.desktop));

function handleToggleMobileMenu() {
	openMbMenu.value = !openMbMenu.value;
	togglePageOverflow(!openMbMenu.value);
}
</script>

<style lang="scss" scoped>
header {
	height: 4rem;
	display: flex;
	align-items: center;
	gap: 0.556rem;
	justify-content: flex-end;
	position: sticky;
	top: 0;
	z-index: var(--z-index-header);
	background-color: var(--color-gray950);

	& > * {
		z-index: var(--z-index-header);
	}

	& .mobile-menu {
		z-index: var(--z-index-mobile-menu);
	}
}

ul {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: 0.5rem;
}

.logo {
	margin-right: auto;
	--icon-width: 4.444rem;
	--icon-height: 1.778rem;
}

.phone {
	@include useFont(tmdb);
	white-space: nowrap;
}

.burger-btn {
	padding: 0;
	position: relative;
	align-items: start;
	justify-content: start;
	@include useFixedSize(2.667rem, 2.667rem);

	&.opened {
		.d1 {
			margin-top: 21px;
			transform: rotate(-45deg);
		}

		.d2 {
			transform: rotate(45deg);
		}

		.d3 {
			opacity: 0;
		}
	}
}

.d1,
.d2,
.d3 {
	width: 1rem;
	height: 0.111rem;
	border-radius: 0.056rem;
	background-color: var(--color-white);
	position: absolute;
	right: 15px;
	left: auto;
	transition: all 0.2s;
	opacity: 1;
	top: 0;
}

.d1 {
	margin-top: 15px;
}

.d2 {
	margin-top: 21px;
}

.d3 {
	width: 0.667rem;
	margin-top: 27px;
}

@include screen768 {
	.logo {
		--icon-width: 8.5rem;
	}

	.phone {
		margin-left: 3.5rem;
	}

	.social-link {
		margin-left: 0.8rem;
	}
}

@include screen1440 {
	header {
		height: 5.778rem;
	}

	ul {
		gap: 2.222rem;
	}

	.logo {
		--icon-width: 14.056rem;
		--icon-height: 1.778rem;
	}

	.phone {
		@include useFont(tlgb);
	}

	.social-link {
		margin-left: 1.333rem;
	}
}

@include screen1920 {
	.phone {
		margin-left: 7.5rem;
	}
}
</style>
